var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-clappr',{attrs:{"el":_vm.htmlId,"source":_vm.source,"options":_vm.options},on:{"init":_vm.oninit,"error":_vm.onerror}})
}
var staticRenderFns = []

export { render, staticRenderFns }